import { render, staticRenderFns } from "./forTeachers.vue?vue&type=template&id=13b8c006"
import script from "./forTeachers.vue?vue&type=script&lang=js"
export * from "./forTeachers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports